












































import GlobalEvent from '@/datatypes/global-event';
import EventService from '@/services/event/event-service';
import SnackbarMessageHandler from '@/components/snackbarMessage.vue';
import Vue from 'vue';
import camelcaseKeysDeep from 'camelcase-keys-deep';

export default Vue.extend({
  data: () => ({
    events: new Array<GlobalEvent>(),
    errorMessage: '',
    nextPointer: undefined as string | undefined,
    eventService: new EventService(),
    totalCount: 0,
  }),

  components: {
    SnackbarMessageHandler,
  },

  mounted() {
    this.routeChanged();
  },

  watch: {
    $route() {
      this.routeChanged();
    },
  },

  computed: {
    hasNext() {
      return typeof this.nextPointer === 'string';
    },
  },

  methods: {
    routeChanged() {
      this.getGlobalEvents();
    },

    getQueryOptions() {
      return {
        next: this.nextPointer,
      };
    },

    concatResponse(data: GlobalEvent[]) {
      this.events = this.events.concat(data);
    },

    getGlobalEvents() {
      this.eventService.getGlobalEvents(this.getQueryOptions()).then((response) => {
        this.concatResponse(response.data.map((data) => new GlobalEvent(camelcaseKeysDeep(data))));
        this.nextPointer = undefined;

        if (this.events.length === 0) {
          this.errorMessage = 'No events found.';
        }

        if (response.headers.total_count) {
          this.totalCount = response.headers.total_count;
        } else {
          this.totalCount = 0;
        }

        if (response.headers.next) {
          this.nextPointer = response.headers.next;
        }
      });
    },

    requestNextPage() {
      this.getGlobalEvents();
    },
  },
});
